import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, getHandle } from "../helpers"
import { useEffect } from "preact/hooks"
import SubmitButton from "./elements/SubmitButton"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    useEffect(()=>{
        setTimeout(() => {
            document.addEventListener('click', function(e) {
                console.log("click", e.target)
                if (e.target.classList.contains('product-card__swatch')) {
                    e.preventDefault();
                }
            });
        }, 1000)
    }, [])

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto ns-pt-0 ns-pl-5 ns-pr-5 ns-pb-5"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">

                <SubmitButton text="VIEW ALL" />
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 ${
                                products?.hits?.length > 0 ? "ns-col-sm-4" : "ns-col-sm-12"
                            }`}
                        >
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Keywords
                            </div> */}
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1 ns-pt-4 ns-pt-sm-0">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            <div class="search-results__products">
                                {products?.hits?.map(hit => {
                                    return (
                                        <div class="product-card-container">
                                            <AutocompleteElement key={hit.productId} hit={hit} as="div">
                                                <nosto-dynamic-card handle={getHandle(hit.url)} template="card">
                                                    <div class="product-card-skeleton"></div>
                                                </nosto-dynamic-card>
                                            </AutocompleteElement>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-4 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
